import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { isEmpty, uniqueId } from 'lodash';
import { styled } from '@mui/system';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import airportVn from '@/mappings/airport_vn.json';
import {
  Box, Button, Dialog, DialogContent, Stack, Typography,
} from '@mui/material';
import { pr } from '@/utils/pxToRem';
import WideTableCellCenter from '@/components/WideTableCellCenter';
import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';
import { format } from 'date-fns';
import { ReserveButton } from './ReserveButton';
import { useBoolean } from '@/utils/hooks';
import RedirectAlert from '../RedirectAlert';
import { useState } from 'react';

const CTABooking = styled('div')`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center; 
  color: ${style.color.product3};
  cursor:pointer;
`;
const StyledPriceText = styled('div')`
  font-weight: bold;
`;

// const FlexTableRow = styled(FlexTableRow)`
//   &:nth-of-type(odd) {
//     background-color: ${style.color.white3};
//   }
// `;

export default function TableFareVcms({
  flightData, selectedDate, onSelectTrip, airline, hideAirline, isDesktop, lang, countResult,
}: any) {
  const date = format(new Date(selectedDate?.depart), 'yyyy-MM-dd');
  let data = flightData ? flightData[date] : [];
  const [open, setOpen] = useBoolean(false);
  const [param, setParam] = useState<any>({});
  if (airline && !isEmpty(data)) {
    data = data.filter((d: any) => d.airline.code === airline);
  }

  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{ background: 'white' }}>
            <WideTableCellCenter
              align="center"
            >
              {lang?.LowestPriceTodayTableWithBar?.start || 'Khởi hành'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.LowestPriceTodayTableWithBar?.cheapestPrice || 'Giá rẻ nhất'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.LowestPriceTodayTableWithBar?.airline || 'Hãng bay'}
            </WideTableCellCenter>
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(data) ? data.slice(0, 6)?.map((row: any) => {
            const idParts = row.id.split('|');
            let fromLocation = '';
            let toLocation = '';
            airportVn.airports.forEach((ap) => {
              if (ap.VxrAreaId === +idParts[6]) {
                fromLocation = ap.CityName_Vi;
              } else if (ap.VxrAreaId === +idParts[7]) {
                toLocation = ap.CityName_Vi;
              }
            });
            return (
              <FlexTableRow
                key={uniqueId()}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <WideTableCellCenter>
                  <StyledPriceText>
                    {row.pickup_time}
                  </StyledPriceText>
                </WideTableCellCenter>
                <WideTableCellCenter>
                  <StyledPriceText sx={{
                    color: style.primary.blue,
                  }}
                  >
                    {convertMoney(row.total_price_adult).replace('đ', (lang?.global?.VND || 'đ'))}
                  </StyledPriceText>
                </WideTableCellCenter>
                <WideTableCellCenter align="center">
                  <StyledPriceText>
                    {row?.airline?.name}
                  </StyledPriceText>
                  <ReserveButton
                    onClick={() => {
                      setParam(row);
                      onSelectTrip(row);
                    }}
                    lang={lang}
                  />
                </WideTableCellCenter>

                {/* {!isDesktop ? null : (
                  <ReserveButton
                    onClick={() => onSelectTrip && onSelectTrip(row)}
                  />
                )} */}
              </FlexTableRow>
            );
          }) : <Box sx={{ p: pr`16px` }}><ShowNoDataDescription lang={lang} /></Box>}
        </TableBody>
        <RedirectAlert
          onConfirm={onSelectTrip}
          params={param}
          open={open}
          setOpen={setOpen}
        />
      </Table>

    </TableContainer>
  );
}
